<template>
	<v-card 
		class="mx-auto"
		flat
		:max-width="maxWidth"
		:loading="loading"
	>
		<v-app-bar flat color="transparent">
			<v-btn v-if="step > 0" icon @click="$emit('previous')">
            	<v-icon>mdi-arrow-left</v-icon>
            </v-btn>
			<v-toolbar-title class="text-h6">
				{{ title }}
			</v-toolbar-title>
		</v-app-bar>
		<v-card-text>
			{{ text }}
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
				<v-btn
					class="mx-2"
					color="indigo"
					dark
					rounded
					block
					@click="$emit('next')"
				>
					Next
				</v-btn>
			<v-spacer></v-spacer>
		</v-card-actions>
	</v-card>
</template>

<script>
import mixin from './mixin/main'

export default {
	mixins: [mixin],
}
</script>
